import { STRIPE_PUBLISHABLE_KEY } from '../../../config'
import schema from '../../../assets/formSchemas/formDataSchema.json'
import formFields from '../../../assets/formSchemas/formFields.json'

export default {
  SET_SUBSCRIPTION_EDIT (state, payload) {
    state.subscriptionToEdit = payload || {}
  },
  SET_AVAILABLE_PRODUCTS (state, payload) {
    state.products = payload
  },
  SET_AVAILABLE_PLANS (state, payload) {
    state.plans = payload
  },
  SET_ACTIVE_SUBSCRIPTIONS (state, payload) {
    state.activeSubscriptions = payload
  },
  SET_MY_SUBSCRIPTIONS (state, payload) {
    state.mySubscriptions = payload
  },
  SET_MY_PAYMENTS (state, payload) {
    state.myPayments = payload
  },
  ADD_SUBSCRIPTION (state, payload) {
    state.mySubscriptions.push(payload)
  },
  CHANGE_SUBSCRIPTION (state, payload) {
    state.mySubscriptions.filter(subscription => subscription.id !== payload.id)
  },
  REMOVE_SUBSCRIPTION (state, payload) {
    state.mySubscriptions = state.mySubscriptions.filter(subscription => subscription.id !== payload.id)
  },
  SET_ACTIVE_USER_SUBSCRIPTIONS (state, payload) {
    state.activeUserSubscriptions = payload || []
  },
  SET_PAYMENT_REQUEST_FIELDSET (state, payload) {
    const fieldset = formFields.paymentRequest
    const paymentRequestProperties = schema['stripe.PaymentRequest'].properties
    let retArray = []

    fieldset.forEach(function (field) {
      if (paymentRequestProperties.hasOwnProperty(field.name)) {
        retArray.push(Object.assign({}, paymentRequestProperties[field.name], field))
      }
    })
    state.paymentRequestSchema = retArray
  },
  SET_STRIPE_PUBLISHABLE_KEY (state, payload) {
    state.stripeKey = STRIPE_PUBLISHABLE_KEY
  }
}



// WEBPACK FOOTER //
// ./src/app/store/subscriptions/mutations.js